import IssueReporter from "./components/IssueReporter";

export default IssueReporter